import { Navigate, useLocation } from "react-router-dom";
import { useAuth } from "../../contexts/AuthContext";
import LoadingIndicator from "../loading-indicator/LoadingIndicator";
import { useEffect, useState } from "react";
import "./ProtectedRoute.scss";

interface ProtectedRouteProps {
  children: JSX.Element;
  blockTrial?: boolean;
}

const ProtectedRoute = ({ children, blockTrial }: ProtectedRouteProps) => {
  const { currentUser, loading, isTrialUser } = useAuth();
  const location = useLocation();
  const [showLoading, setShowLoading] = useState(false);

  useEffect(() => {
    // Only show loading indicator for a very short time on initial load
    if (loading) {
      setShowLoading(true);
      const timer = setTimeout(() => {
        setShowLoading(false);
      }, 100); // Very short delay to prevent flicker
      return () => clearTimeout(timer);
    }
  }, [loading]);

  if (loading) {
    return showLoading ? (
      <div className="minimal-loading">
        <LoadingIndicator message="" />
      </div>
    ) : null;
  }

  if (!currentUser) {
    try {
      sessionStorage.setItem('postLoginRedirect', location.pathname + location.search);
    } catch { /* storage blocked — route state is the fallback */ }
    return <Navigate to="/login" replace state={{ from: location }} />;
  }

  if (blockTrial && isTrialUser) {
    return <Navigate to="/" replace />;
  }

  return children;
};

export default ProtectedRoute;